import React from 'react';
import { Link } from 'react-router-dom'; // Agar React Router use kar rahe ho toh

const Request = () => {
  return (
    <div className="request-video py-20 px-6 bg-gradient-to-r from-purple-700 via-indigo-800 to-blue-900 min-h-screen flex flex-col justify-center">
      <div className="heading-section text-center mb-16 max-w-3xl mx-auto">
        <h2 className="text-5xl font-extrabold text-transparent bg-clip-text bg-gradient-to-r from-purple-400 via-pink-500 to-yellow-400 select-none">
          Our Work Video
        </h2>
        <p className="subheading mt-4 text-xl md:text-2xl text-gray-300 max-w-xl mx-auto leading-relaxed">
          Discover our services and how we make a difference through this brief video.
        </p>
      </div>

      <div className="video-container relative w-full max-w-5xl mx-auto h-0 pb-[56.25%] rounded-3xl overflow-hidden shadow-2xl transition-transform duration-500 hover:scale-105">
        <iframe
          className="absolute inset-0 w-full h-full"
          src="https://www.youtube.com/embed/7TyHfAJyQCk"
          title="Work Video"
          frameBorder="0"
          allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        ></iframe>
      </div>

      <div className="text-center mt-16">
        <Link
          to="/contact"
          className="inline-block bg-yellow-500 text-white font-semibold text-lg py-4 px-12 rounded-3xl shadow-lg hover:bg-yellow-400 hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-1 hover:scale-110 select-none"
        >
          Contact Us for More Details
        </Link>
      </div>
    </div>
  );
};

export default Request;
